var site = site || {};
jQuery(document).ready(function ($) {
  $(window).on('window:show_afterpay_overlay', function() {
    var content = (site.client.isMobile == 1) ? $('.afterpay-content-mb') : $('.afterpay-content');
    if (content.length > 0) {
      generic.overlay.launch({
        content: content.clone(true).removeClass('hidden'),
        includeBackground: true,
        includeCloseLink: true,
        initialHeight: 0,
        cssStyle:{
            width: 611,
            height: 560,
        }
      });
    }
  });

  $('body').on('click', '#ap-learnmore', function() {
    $(window).trigger('window:show_afterpay_overlay');
      return false;
  });
});
